import {
  RETRIEVE_USERS,
  RETRIEVE_LOGGEDIN_USER,
  UPDATE_USER,
  UPDATE_USER_STATUS,
  RESTORE_USER,
  DELETE_USER,
  CREATE_USER,
} from "../actions/types";

const initialState = { users: [], totalUserCount: 0 };

const userReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_USERS:
      return {
        users: payload.rows,
        totalUserCount: payload.count,
      };

    case RETRIEVE_LOGGEDIN_USER:
      return payload;

    case CREATE_USER:
      return payload;

    case UPDATE_USER:
      return payload;

    case UPDATE_USER_STATUS:
      return {
        users: payload.rows,
        totalUserCount: state.totalUserCount,
      };

    case DELETE_USER:
      return {
        ...state,
        users: payload.rows,
        totalUserCount: state.totalUserCount,
      };

    case RESTORE_USER:
      return {
        ...state,
        users: payload.rows,
        totalUserCount: state.totalUserCount,
      };


    default:
      return state;
  }
};

export default userReducer;